/**
 * Main Entry Point
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// After a deploy the previous build's code chunks are gone, so a tab opened
// before it fails to load its next page ("Something went wrong" until a
// manual reload). Reload once to pick up the new build -- never in a loop:
// not again within a minute of the last such reload.
window.addEventListener("vite:preloadError", (event) => {
  const key = "ilmiq-chunk-reload-at";
  try {
    const last = Number(sessionStorage.getItem(key) ?? 0);
    if (Date.now() - last < 60_000) return;
    sessionStorage.setItem(key, String(Date.now()));
  } catch {
    return; // no storage: no way to guard a loop, so don't reload
  }
  event.preventDefault();
  window.location.reload();
});

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
